import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import {MatRippleModule} from '@angular/material/core';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,

    MatSnackBarModule,
    MatCardModule,
    MatButtonModule,
    MatDialogModule,
    MatRippleModule,
    MatToolbarModule,
    MatIconModule

  ], exports: [
    MatSliderModule,
    MatSnackBarModule,
    MatButtonModule,
    MatDialogModule,
    MatRippleModule,
    MatCardModule,
    MatToolbarModule,
    MatIconModule

  ]
})
export class MaterialModule { }
